import { Component, input } from '@angular/core';

@Component({
  selector: 'app-box-1',
  standalone: true,
  imports: [
  ],
  templateUrl: './box-1.component.html',
  styleUrls: ['./box-1.component.scss'],
  host: {
    style: 'display: block; width: 100%; height: fit-content;'
  }
})
export class Box1Component {
  public padding = input<number>(16);
  public borderWidth = input<number>(1);
  public borderRadius = input<number>(16);
}
  